import { Box, IconButton, Stack, Typography } from '@mui/material';
import { CaretLeftIcon, XIcon } from '@phosphor-icons/react';

interface ScreenHeaderProps {
  title: string;
  onBack?: () => void;
  onClose: () => void;
}

export function ScreenHeader({ title, onBack, onClose }: ScreenHeaderProps) {
  return (
    <Stack direction="row" sx={{ alignItems: 'center', px: 2.5, py: 2, borderBottom: '1px solid', borderColor: 'divider' }}>
      {onBack ? (
        <IconButton onClick={onBack} aria-label="Back" sx={{ ml: -1, mr: 0.5 }}>
          <CaretLeftIcon size={20} />
        </IconButton>
      ) : null}
      <Typography variant="h6" sx={{ fontWeight: 700, flex: 1 }}>
        {title}
      </Typography>
      <Box sx={{ ml: 1 }}>
        <IconButton onClick={onClose} aria-label="Close">
          <XIcon size={20} />
        </IconButton>
      </Box>
    </Stack>
  );
}
